import { Injectable, signal } from '@angular/core';

import { DepositInfo } from '../model/depositInfo.model';

@Injectable({
    providedIn: 'root',
})
export class DataService {
    depositProcess = signal<boolean>(false);
    _manifestData: { [key: string]: string } = {};
    public get manifestData(): { [key: string]: string } {
        return this._manifestData;
    }
    public set manifestData(value: { [key: string]: string }) {
        this._manifestData = value;
    }
    _sessionInfo: any;
    error = signal<any>(null);
    data: any;
    _depositInfo: DepositInfo;
    _rgLimitData = [];
    _worldPaySessionId: any;
    _callSuccessApi: boolean = false;

    set sessionInfo(_sessionInfo: any) {
        this._sessionInfo = _sessionInfo;
    }

    get sessionInfo() {
        return this._sessionInfo;
    }
    set depositInfo(depositInfo: DepositInfo) {
        this._depositInfo = depositInfo;
    }
    get depositInfo() {
        return this._depositInfo;
    }

    set RgLimitData(inputData) {
        this._rgLimitData = inputData;
    }
    get RgLimitData() {
        return this._rgLimitData;
    }

    set worldPaySessionId(_worldPaySessionId) {
        this._worldPaySessionId = _worldPaySessionId;
    }
    get worldPaySessionId() {
        return this._worldPaySessionId;
    }
}
